import { useState, useEffect, useRef } from 'react';
import Search from '@Services/Search';
import QueryParser from '@Services/QueryParser';
import AppStorage from '@Services/AppStorage';

export const OPERATORS_CACHE_KEY = 'operators';

export const clearOperatorsCache = () => AppStorage.instance.removeFromSessionStorage(OPERATORS_CACHE_KEY);

export default function useFetchOperatorData() {
  const [operators, setOperatorList] = useState([]);
  const isMounted = useRef(true);

  useEffect(() => {
    const NOT_ALLOWED_OPERATORS = ['COMBINE']; // COMBINE operator is not allowed to use with all querylets, only some forms
    const fetchData = async () => {
      try {
        const cachedOperators = AppStorage.instance.getFromSessionStorage(OPERATORS_CACHE_KEY);

        if (cachedOperators && cachedOperators.length > 0) {
          setOperatorList(cachedOperators);
          QueryParser.setLogicOperatorsMap(cachedOperators);
          return;
        }

        const data = await Search.getExistingLogicOperators();
        const operatorsList = data.filter(({ operator }) => NOT_ALLOWED_OPERATORS.indexOf(operator) === -1);
        const transformedData = operatorsList.map((operatorVal) => ({
          label: operatorVal.operator,
          id: operatorVal.operator,
          supportsQualifier: operatorVal.supportsQualifier ? operatorVal.supportsQualifier : false,
          defaultQualifier: operatorVal.supportsQualifier ? operatorVal.defaultQualifier : 0,
          lowerQualifierBound: operatorVal.supportsQualifier ? operatorVal.lowerQualifierBound : 0,
          upperQualifierBound: operatorVal.supportsQualifier ? operatorVal.upperQualifierBound : 0,
        }));

        AppStorage.instance.setToSessionStorage(OPERATORS_CACHE_KEY, transformedData);

        setOperatorList(transformedData);
        QueryParser.setLogicOperatorsMap(transformedData);
      } catch (error) {
        Logger.error(error);
      }
    };

    fetchData();
    return () => {
      isMounted.current = false;
    };
  }, []);
  return { operators };
}
